// extracted by mini-css-extract-plugin
export var externalLink = "_9e-0";
export var internalLinkLabel = "_9e-1";